import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import GetInvolved from './components/GetInvolved';
import LearnMore from './components/LearnMore';
import Admin from './Admin';
import NewsletterArchive from './components/NewsletterArchive';
import './App.css';
import logo from './images/niaarav.com.jpeg';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  if (isAdminRoute) {
    return (
      <Routes>
        <Route path="/admin/*" element={<Admin />} />
        {/* fallback for any other admin subroutes */}
      </Routes>
    );
  }

  return (
    <>
      <header className="App-header">
        <div className="logo-container">
          <img src={logo} alt="Niaarav Logo" className="App-logo" />
        </div>
        <h1>Welcome to our Nonprofit Niaarav</h1>
        <nav className="nav-bar">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About</Link>
          <Link to="/get-involved" className="nav-link">Get Involved</Link>
        </nav>
      </header>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/get-involved" element={<GetInvolved />} />
        <Route path="/learn-more" element={<LearnMore />} />
        <Route path="/newsletter-archive" element={<NewsletterArchive />} />
      </Routes>

      <nav className="bottom-nav">
        <Link to="/get-involved" className="nav-link">Get Involved</Link>
        <Link to="/learn-more" className="nav-link">Learn More</Link>
        <Link to="/newsletter-archive" className="nav-link">Newsletter Archive</Link>
      </nav>
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <AppContent />
      </div>
    </Router>
  );
}

export default App;
